import "./App.css";
import "./assets/css/assets.css";
import "./assets/css/style.css";
// import Home from "../src/components/Home";
import { Route, Routes, useLocation } from "react-router-dom";
// import CourseDetails from "./components/Courses/CourseDetails";
// import Header from "./components/Home/Header";
// import MainContactUs from "./components/MainContactUs/MainContactUs";
import { useEffect, lazy, Suspense, useState } from "react";
// import Footer from "./components/Home/Footer";
// import PrivacyPolicy from "./components/PrivacyPolicy";
// import TermsCondition from "./components/TermsCondition";
// import AboutUs from "./components/AboutUs";
import whatApp from "./assets/images/newwhatAppIcon.png";
import AI from "./assets/AI.png";
import CoursesUpdate from "./components/Admin/CoursesUpdate/CoursesUpdate";
import { HelmetProvider } from "react-helmet-async";
import Loader from "./components/Loader";
import Login from "./components/Login/Login";
import { CiLogin } from "react-icons/ci";
import Collection from "./components/Home/Collection";
import Sidebar from "./components/Admin/Sidebar/Sidebar";
import ChatApp from "./components/ChatApp";
import Dashboard from "./components/Admin/Dashboard/Dashboard";
import Inquiry from "./components/Admin/Inquiry/Inquiry";
import Logout from "./components/Admin/Logout/Logout";
import ChatBot from "./components/Admin/ChatBot/ChatBot";
import StudentDashboard from "./components/StudentAdmin/StudentDashboard/StudentDashboard";
import Singup from "./components/Singup/Singup";
import Forgot from "./components/Forget/Forgot";
import ResetPassword from "./components/resetPassword/Reset-Password";
import InquiryAdmin from "./components/StudentAdmin/InquiryAdmin/InquiryAdmin";
// Lazy-loaded components
const Home = lazy(() => import("./components/Home"));
const CourseDetails = lazy(() => import("./components/Courses/CourseDetails"));
const Header = lazy(() => import("./components/Home/Header"));
const MainContactUs = lazy(() => import("./components/MainContactUs/MainContactUs"));
const Footer = lazy(() => import("./components/Home/Footer"));
const PrivacyPolicy = lazy(() => import("./components/PrivacyPolicy"));
const TermsCondition = lazy(() => import("./components/TermsCondition"));
const AboutUs = lazy(() => import("./components/AboutUs"));



function App() {
  let location = useLocation();


  // Correctly define the state for ChatApp visibility
  // const [showChatApp, setShowChatApp] = useState(false);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://www.googletagmanager.com/gtag/js?id=G-WLZYHEEE13";
    script.async = true;
    document.head.appendChild(script);

    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      window.gtag = function gtag() {
        window.dataLayer.push(arguments);
      };
      window.gtag("js", new Date());
      window.gtag("config", "G-WLZYHEEE13");
      window.gtag("event", "page_view", { page_path: location.pathname });
    };
  }, []);

  useEffect(() => {
    if (window.gtag) {
      window.gtag("event", "page_view", { page_path: location.pathname });
    }
  }, [location.pathname]);

  const openWhatsAppChat = () => {
    const phoneNumber = "9926640515";
    const url = `https://wa.me/${phoneNumber}`;
    window.open(url, "_blank");
  };



  //  ChatApp visibility
  // const toggleChatApp = () => {
  //   setShowChatApp((prev) => {
  //     console.log("Previous state:", prev);
  //     console.log("New state:", !prev);
  //     return !prev;
  //   });
  // };
  return (
    <HelmetProvider>

      <Suspense fallback={<Loader />}>
        <div id="bg">
          {!["/login", "/ChatApp", "/Dashboard", "/Inquiry", "/logout", "/chatbots", "/courses", "/StudentDashboard", "/Singup","/forgot-password","/reset/:token","/InquiryAdmin","/coursesAdmin"].includes(location.pathname) && <Header />}

          <ChatApp />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route
              path="/IT-training-course-indore"
              element={<CourseDetails />}
            />
            <Route path="/Contact-Us" element={<MainContactUs />} />
            <Route path="/Price&Policy" element={<PrivacyPolicy />} />
            <Route path="/Terms&Conditions" element={<TermsCondition />} />
            <Route path="/About-us" element={<AboutUs />} />
            <Route path="/login" element={<Login />} />
            <Route path="/Collection" element={<Collection />} />
            <Route path="/Sidebar" element={<Sidebar />} />
            <Route path="/Dashboard" element={<Dashboard />} />
            <Route path="/inquiry" element={<Inquiry />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="/chatbots" element={<ChatBot />} />
            <Route path="/courses" element={<CoursesUpdate />} />
            <Route path="/StudentDashboard" element={<StudentDashboard />} />
            <Route path="/Singup" element={<Singup />} />
            <Route path="/forgot-password" element={<Forgot />} />
            <Route path="/reset/:token" element={<ResetPassword />} />
            <Route path="/InquiryAdmin" element={<InquiryAdmin />} />


          </Routes>

          {!["/login",  "/ChatApp", "/Dashboard", "/Inquiry", "/logout", "/chatbots", "/courses", "/StudentDashboard", "/Singup","/forgot-password","/reset/:token","/InquiryAdmin","/coursesAdmin"].includes(location.pathname) && <Footer />}


          <div className="chatBot" onClick={openWhatsAppChat}>
            <img src={whatApp} alt="chatBot" />
          </div>
        </div>
      </Suspense>
    </HelmetProvider>
  );
}

export default App;
